import { memo } from 'react';
import Card from '../../../component/card/Card.component';
import ButtonLink from '../../../component/buttton/ButtonLink.component';
import FontBold from '../../../component/fontBold/FontBold.component';
import Grid from '@material-ui/core/Grid';
import GridComponentComponent from '../../../component/grid/GridComponent.component';
import { HeightText } from '../../../component/heightText/HeightText.component';

interface CardBodyInterface {
    title: string;
    timeCourse: string;
    id?: string;
}

const CardBody = ({ title, timeCourse, id }: CardBodyInterface) => {

    return (
        <Grid item xs={12} sm={6} md={6} lg={4} xl={3} >
            <Card color="#FBFBFB" padding={'0px 12px 20px 12px'}  >
                <GridComponentComponent direction='column' alignItems='flex-start' justify='space-between' >
                    <HeightText>
                        <FontBold title={title} isUpperCase={true} color='#095AA5' fontSize={20} />
                    </HeightText>
                    <FontBold title="Período: " subTitle={timeCourse} isUpperCase={true} />

                    <ButtonLink title="abrir" size='medium' link={`/comunicado-corporativo/view-comunicado/${id}`} />

                </GridComponentComponent>
            </Card>
        </Grid>
    )
}

export default memo(CardBody);
